<template>
  <div id="error">
    <dd-header />
    <main>
        <div v-for="(message, index) in errorMessages" :key="'error-' + index">{{message}}</div>
        <div class="toplink"><a @click="toLogin()">ログイン画面へ戻る</a></div>
    </main>
  </div>
</template>
<script>
import Header from '../components/common/Header'

export default {
  name: 'Error',
  components: {
    'dd-header': Header
  },
  data () {
    return {
      errorMessages: ['システムエラーが発生しました。', 'しばらく時間をおいてから、再度操作してください。']
    }
  },
  methods: {
    toLogin: function () {
      this.$router.push({
        name: 'Login'
      })
    }
  },
  created () {
    if (this.$route.params.errorMessages) {
      this.errorMessages = this.$route.params.errorMessages
    }
  }
}
</script>

<style lang="scss" scoped>
#error {
  height: calc(100% - 140px);
}
main {
  height: 100%;
  padding: 20px;
  text-align: center;
  background-color: white;
  color: #ff4500;
  font-weight: bold;
  line-height: 25px;
  .toplink {
    margin-top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Error.vue